<div class="overview-checks-tab--container" data-cy="iot-platform-feature-data-guard-overview-checks-tab">
  @if (loading()) {
    <iot-platform-ui-card-loader [backgroundClass]="'h-100'" />
  } @else {
    @for (check of overviewChecks(); track check.source.id) {
      <iot-platform-feature-data-guard-overview-check [overviewCheck]="check" (click)="onCheckClick(check)" />
    }
  }
</div>
